import { AxiosResponse } from 'axios';
import { getData } from '../../../utils/fetch-api-util';
import { API_URLS } from '../../../constants/urls/api-urls';

export interface CountryOption {
  code: string;
  name: string;
  status: string;
}

export const getCountryListRepository = async (): Promise<CountryOption[]> => {
  const response: AxiosResponse<any> = await getData(
    API_URLS.COUNTRY_LIST,
    undefined,
    undefined,
    process.env.REACT_APP_LOGIN_ADMIN_PORTAL_CLIENT_ID,
  );

  const countries = response?.data;
  return countries;
};
